export const theads = [
  'SL No',
  'Customer',
  'Date',
  'Phone No',
  'Subject',
  'Message',
];

export const columns = [
  { title: 'SL No', data: 'SL No' },
  { title: 'Customer', data: 'Customer' },
  { title: 'Date', data: 'Date' },
  { title: 'Phone No', data: 'Phone No' },
  { title: 'Subject', data: 'Subject' },
  { title: 'Message', data: 'Message' },
];

export const commonDtOptions = {
  pagingType: 'simple_numbers',
  serverSide: true,
  processing: true,
  buttons: ['csv', 'print', 'excel'],
  dom: 'Blfrtip',
  ordering: false,
  columns: columns,
  lengthChange: true,
  pageLength: 10,
  lengthMenu: [
    10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 120, 140, 160, 180, 200, 240, 280,
    300, 400, 500,
  ],
};
